import Link from "next/link";

const footer = () => {
  return (
    <>
      {/* <!-- Footer --> */}
      <footer className="dark:bg-jacarta-900 page-footer bg-white">
        <div className="container">
          <div className="grid grid-cols-6 gap-x-7 gap-y-14 pt-24 pb-12 md:grid-cols-12">
            <div className="col-span-3 md:col-span-4">
              {/* <!-- Logo --> */}
              <Link href="/">
                <a className="mb-6 inline-block">
                  <img
                    src="/images/logo.png"
                    className="max-h-24 dark:hidden"
                    alt="GMJA Arc-Hive"
                  />
                </a>
              </Link>
              <Link href="/">
                <a className="mb-6 inline-block">
                  <img
                    src="/images/logo_white.png"
                    className="hidden max-h-24 dark:block"
                    alt="GMJA Arc-Hive"
                  />
                </a>
              </Link>
              <p className="dark:text-jacarta-300 mb-12">
                Discover, create, and explore exclusive collections and
                Articles. Let us help you connect with our curated content.
              </p>

              {/* <!-- Socials --> */}
              <div className="flex space-x-5">
                <Link href="https://facebook.com">
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group cursor-pointer"
                  >
                    <svg className="icon group-hover:fill-green fill-jacarta-300 h-5 w-5 dark:group-hover:fill-white">
                      <use xlinkHref={`/icons.svg#icon-facebook`}></use>
                    </svg>
                  </a>
                </Link>
                <Link href="https://twitter.com">
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group cursor-pointer"
                  >
                    <svg className="icon group-hover:fill-green fill-jacarta-300 h-5 w-5 dark:group-hover:fill-white">
                      <use xlinkHref={`/icons.svg#icon-twitter`}></use>
                    </svg>
                  </a>
                </Link>
                <Link href="https://instagram.com">
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group cursor-pointer"
                  >
                    <svg className="icon group-hover:fill-green fill-jacarta-300 h-5 w-5 dark:group-hover:fill-white">
                      <use xlinkHref={`/icons.svg#icon-instagram`}></use>
                    </svg>
                  </a>
                </Link>
              </div>
            </div>

            {/* Footer Menu */}
            <div className="col-span-full sm:col-span-3 md:col-span-2">
              <h3 className="font-display text-jacarta-700 mb-6 text-sm dark:text-white">
                Navigation
              </h3>
              <ul className="dark:text-jacarta-300 flex flex-col space-y-1">
                <li>
                  <Link href="/">
                    <a className="hover:text-green dark:hover:text-white">
                      Home
                    </a>
                  </Link>
                </li>
                <li>
                  <Link href="/about">
                    <a className="hover:text-green dark:hover:text-white">
                      About
                    </a>
                  </Link>
                </li>
                <li>
                  <Link href="/categories">
                    <a className="hover:text-green dark:hover:text-white">
                      Categories
                    </a>
                  </Link>
                </li>
                <li>
                  <Link href="/articles">
                    <a className="hover:text-green dark:hover:text-white">
                      Articles
                    </a>
                  </Link>
                </li>
                <li>
                  <Link href="/contact">
                    <a className="hover:text-green dark:hover:text-white">
                      Contact
                    </a>
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          <div className="flex flex-col items-center justify-between space-y-2 py-8 sm:flex-row sm:space-y-0">
            <span className="dark:text-jacarta-400 text-sm">
              <span>
                © {new Date().getFullYear()} Tikur Digital Trading — Crafted
                with care.
              </span>
            </span>

            <ul className="dark:text-jacarta-400 flex flex-wrap space-x-4 text-sm">
              <li>
                <Link href="/terms">
                  <a className="hover:text-green dark:hover:text-white">
                    Terms and Conditions
                  </a>
                </Link>
              </li>
              <li>
                <Link href="/privacy">
                  <a className="hover:text-green dark:hover:text-white">
                    Privacy Policy
                  </a>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </footer>
    </>
  );
};

export default footer;
